import React, { Fragment, useState } from "react";
import ProductNewPriceForm from "components/ProductForm/ProductNewPriceForm";
import ProductPriceForm from "components/ProductForm/ProductPriceForm";
import { useCtxReferences, useIsAuthed, useProduct } from "utils/selectors";
import { PRODUCT_PRICE_INTENT } from "utils/constants/pricing";
import AllProductPrices from "./AllProductPrices";
import Overlay from "components/Overlay";

/**
 * Composite product prices component used outside of the builder menu flow
 * - All navigation state held locally as it doesnt need to be shared amongst other components (unlike builder)
 * @param {Object} params
 * @param {String} params.uid
 * @param {String} params.resource
 * @param {String} params.resourceUUID
 * @param {String} params.merchantAccountUUID
 */
const ProductPricesPicker = ({
  uid,
  resource,
  resourceUUID,
  goBack,
  onSelect,
  activePrices
}) => {
  const isAuthed = useIsAuthed();
  const { application, merchantAccount } = useCtxReferences();
  const appMerchantProps = {
    applicationUUID: application.uuid,
    merchantAccountUUID: merchantAccount.uuid
  };
  const product = useProduct(uid);
  const [activeSection, setActiveSection] = useState(
    PRODUCT_PRICE_INTENT.ALL_PRICES
  );

  const [activePrice, setActivePrice] = useState(null);
  const activePriceModel =
    product && product.prices.find((price) => price.id === activePrice);

  let content = null;
  const showAllPrices =
    activeSection === PRODUCT_PRICE_INTENT.ALL_PRICES && product;
  const showPrice =
    activeSection === PRODUCT_PRICE_INTENT.SHOW_PRICE &&
    activePrice &&
    activePriceModel &&
    product &&
    isAuthed;
  const showNewPrice =
    activeSection === PRODUCT_PRICE_INTENT.NEW_PRICE && isAuthed;

  const backToIndex = () => {
    setActiveSection(PRODUCT_PRICE_INTENT.ALL_PRICES);
    setActivePrice(null);
  };

  if (showAllPrices) {
    content = (
      <AllProductPrices
        uid={uid}
        product={product}
        onSelect={onSelect}
        setActiveSection={setActiveSection}
        goBack={goBack}
        activePrices={activePrices}
      />
    );
  } else if (showPrice) {
    const priceFormProps = {
      uid: activePrice,
      product,
      price: activePriceModel,
      goBack: backToIndex,
      resource,
      resourceUUID,
      navToProductPriceCreate: () =>
        setActiveSection(PRODUCT_PRICE_INTENT.NEW_PRICE),
      ...appMerchantProps
    };
    content = <ProductPriceForm {...priceFormProps} />;
  }

  return (
    <Fragment>
      {content}
      {showNewPrice && (
        <Overlay hideOverlay={backToIndex}>
          <div className="ph3 pt5">
            <ProductNewPriceForm
              uid={uid}
              goBack={backToIndex}
              resource={resource}
              product={product}
              resourceUUID={resourceUUID}
              {...appMerchantProps}
              customClasses={{
                navHeader: {
                  label: "fw6 f3 pl2 word-break",
                  container:
                    "flex flex-row justify-between items-center pb3 sticky bb hairline-1 bg-white top-0 z-1"
                },
                priceList: "bg-white h-100 pt3"
              }}
            />
          </div>
        </Overlay>
      )}
    </Fragment>
  );
};

export default ProductPricesPicker;
